var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 5.98885C1.33398 5.98885 4.31875 2.65552 8.00065 2.65552C11.6825 2.65552 14.6673 5.98885 14.6673 5.98885",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3633 9.35227C14.566 9.63647 14.6673 9.7786 14.6673 9.98893C14.6673 10.1993 14.566 10.3414 14.3633 10.6256C13.4526 11.9027 11.1268 14.6556 8.00065 14.6556C4.8745 14.6556 2.54872 11.9027 1.63801 10.6256C1.43532 10.3414 1.33398 10.1993 1.33398 9.98893C1.33398 9.7786 1.43532 9.63647 1.63801 9.35227C2.54872 8.0752 4.8745 5.32227 8.00065 5.32227C11.1268 5.32227 13.4526 8.0752 14.3633 9.35227Z",
    stroke: "#6D6D6D",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.98877C10 8.88417 9.1046 7.98877 8 7.98877C6.8954 7.98877 6 8.88417 6 9.98877C6 11.0934 6.8954 11.9888 8 11.9888C9.1046 11.9888 10 11.0934 10 9.98877Z",
    stroke: "#6D6D6D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.eed7822e1425caa82b6a3320f1d4e835.svg";
export { ForwardRef as ReactComponent };